// Single fetch wrapper for the deposits server. Adds Authorization: Bearer
// and parses the standard {success, data, error} envelope.

const TOKEN_KEY = 'deposits.session.token';

export function getToken(): string | null {
  return sessionStorage.getItem(TOKEN_KEY);
}
export function setToken(token: string | null): void {
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  else sessionStorage.removeItem(TOKEN_KEY);
}

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function apiFetch<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const token = getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...((init.headers as Record<string, string>) || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`/api${path}`, { ...init, headers });
  const text = await res.text();
  let body: any = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    /* non-JSON response */
  }

  if (!res.ok) {
    const msg = body?.error || `HTTP ${res.status}`;
    throw new ApiError(msg, res.status);
  }

  // Server envelope: {success, data, ...}. Return the inner data when present;
  // some endpoints (e.g. health) return their fields at the top level.
  if (body && 'success' in body && 'data' in body) return body.data as T;
  return body as T;
}
